import React, { useState } from 'react';
import { Popover } from 'antd';
import { Icon, IconName } from 'components/Icon/Icon';
import { NewButton } from 'components/Button/NewButton/NewButton';
import style from './PopNew.module.scss';

interface IProps {
	children: React.ReactNode;
	content: React.ReactNode;
	trigger: 'hover' | 'focus' | 'click';
}

export const PopNew: React.FC<IProps> = React.memo(({ children, content, trigger }) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const handleVisibleChange = (value: boolean) => {
		setIsOpen(value);
	};

	const close = () => {
		setIsOpen(false);
	};

	const renderContent = () => {
		return (
			<>
				<div className={style.closeButton}>
					<NewButton
						variant="ghost"
						color="gray"
						size="small"
						icon={true}
						iconLeft={<Icon name={IconName.close} />}
						onClick={close}
					/>
				</div>
				{content}
			</>
		);
	};

	return (
		<Popover
			overlayClassName={style.container}
			placement="bottomLeft"
			content={renderContent}
			trigger={trigger}
			visible={isOpen}
			onVisibleChange={handleVisibleChange}>
			{children}
		</Popover>
	);
});
